// extracted by mini-css-extract-plugin
export default {"subsectionContent":"SubsectionTitle_subsectionContent__GgCWV"};